module.exports = __webpack_public_path__ + "media/svg/gr-8fb75d94.svg";